import { useState } from "react";
import useCreate from "../useCreate";
import toast from 'react-hot-toast';

const useDeleteCertificate = () => {
  const [certificateId, setCertificateId] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const { setDataToServer } = useCreate({
    url: 'certificate/delete',
    refreshUrl: 'certificate/list',
    onSuccess: () => {
      toast.success("Certificate Deleted Successfully", {
        position: "top-right",
        duration: 3000
      });
      setDeleteModalOpen(false);
    }
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return {
    certificateId,
    setCertificateId,
    isDeleteModalOpen,
    setDeleteModalOpen,
    handleSubmit,
  };
};

export default useDeleteCertificate;
